/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint react/prop-types: off */
import { FormInput, FormInputDate, FormInputTextArea, Icon } from 'camino-react'
import React, { useState, useEffect } from 'react'
import moment from 'moment-timezone'
import { filter, get, isEmpty, maxBy, sortBy, findLastIndex } from 'lodash'

const Timeline = ({ comments: commentsProps, currentUser, setReport, report, canEdit }) => {
  const [comments, setComments] = useState([])

  const addTimelineEntry = () => {
    const newComment = {
      content: '',
      created_at: new Date(),
      user_name: currentUser.name,
      user_id: currentUser.id,
      tempId: comments.length + get(maxBy(comments, 'id'), 'id', 0) + 1,
      custom: true
    }

    setComments(oldComments => [...oldComments, newComment])
  }

  const removeTimelineEntry = (comment) => {
    handleUpdate('to_delete', true, comment.id || comment.tempId)
  }

  const handleUpdate = (field, value, id) => {
    const newComments = [...comments]
    const commentToUpdate = newComments.find(c => c.id === id || c.tempId === id)
    commentToUpdate[field] = value

    setComments(newComments)
    report.comments = newComments
    setReport(report)
  }

  useEffect(() => setComments(commentsProps), [commentsProps])

  return (
    <>
      <h3 className="m-0 mb-4">Timeline</h3>
      <div className="">
        {sortBy(filter(comments, comment => comment.to_delete !== true), 'created_at')?.map((comment, index) => (
          <div className="flex">
            <div className="flex flex-col items-center mr-4">
              <button
                disabled={!canEdit}
                className="w-9 h-9 border-2 border-blue-500 hover:border-red-700 rounded-full text-2xl text-blue-500 duration-300 hover:text-red-700"
                type="button"
                onClick={() => removeTimelineEntry(comment)}
              >
                <Icon type="trash2" />
              </button>

              <div className={`w-1 h-full bg-blue-500 flex-1 ${findLastIndex(comments, c => c.to_delete !== true) === (index) && 'hidden'}`} />
            </div>

            <div className="w-full pb-8">
              <div className="text-xl">
                {!comment.tempId && (moment(comment.created_at).format('DD MMM YYYY HH:mm'))}
              </div>

              <div className="font-medium text-3xl mb-2">
                {comment.tempId && (
                  <div>
                    <div className="text-2xl w-56">
                      <FormInput label="Timestamp">
                        <FormInputDate
                          enableTime
                          onValue={value => handleUpdate('created_at', value, (comment.id || comment.tempId))}
                          value={comment.created_at}
                        />
                      </FormInput>
                    </div>
                  </div>
                )}
                {!comment.tempId && (comment.user_name)}
              </div>

              <FormInputTextArea
                value={comment.content}
                onValue={value => handleUpdate('content', value, (comment.id || comment.tempId))}
              />
            </div>
          </div>
        ))}

        {isEmpty(comments) && <div>There is no timeline for this incident</div>}
        {canEdit && (
          <span className="link mt-4" onClick={() => addTimelineEntry()}>Add timeline entry</span>
        )}
      </div>
    </>
  )
}

export default Timeline
